import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Toast from "../components/Toast/Toast";

export default function BookStud() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/studs");
    }, 1500);
    return () => clearTimeout(timer);
  }, [navigate]);

  return visible ? (
    <Toast
      message="Stud services must be scheduled by phone"
      type="warning"
      onClose={() => setVisible(false)}
    />
  ) : null;
}
